import { DeliveryDropOffLocation, Location, SearchLocation } from './locations';
import { CancellationReason, OrderType } from '../dtos/deliveries';
import { TimeSlotWithDate } from './timeslot';
import { DeliveryOption } from '../../types';

export interface DeliveryRequest {
  userPhoneNumber: string;
  pickupLocation: Location;
  dropOffLocation?: SearchLocation;
  deliveryDetails?: string;
  customerName?: string;
  customerPhoneNumber?: string;
  paymentMethodId: number;
  paymentType?: string;
  cashOnDelivery?: number;
  orderId?: string;
  orderType?: OrderType;
  useCredit?: boolean;
  deliveryAction?: DeliveryAction;
  buildingName?: string;
  paymentMethodOnDelivery?: PaymentOnDeliveryType;
  deliveryWindow?: TimeSlotWithDate;
  isBookingFree?: boolean;
}

export enum DeliveryStatus {
  /**
   * Delivery created, but captain is not assigned yet
   */
  Pending = 'pending',

  /**
   * Delivery was assigned to a specific captain
   */
  Assigned = 'assigned',

  /**
   * Captain arrived to the pickup location
   */
  AtPickup = 'arrived',

  /**
   * Captain got the package and is on the way from the pickup to the dropoff
   */
  InProgress = 'inProgress',

  /**
   * Package was succesfully delivered
   */
  Delivered = 'delivered',

  /**
   * Delivery was cancelled
   */
  Cancelled = 'cancelled',

  /**
   * Delivery was cancelled due to driver not found
   */
  CNF = 'cnf'
}

export interface DriverDetails {
  driverName: string;
  driverNumber: string;
  notesToDriver?: string;
  driverPicture?: string;
}

export interface Passenger {
  firstName: string;
  lastName: string;
  phoneNumber?: string;
}

export interface Vehicle {
  vehicleModel: string;
  plateNumber: string;
}

export interface Delivery {
  id: number | string;
  bookingId: string;
  status: DeliveryStatus;
  pickUpTime?: Date;
  pickupLocation?: Location;
  dropOffLocation?: DeliveryDropOffLocation;
  driverDetails?: DriverDetails;
  distance?: number;
  price?: number;
  priceCurrency?: string;
  dropOffTime?: Date;
  isCNF?: boolean;
  eta?: number;
  driverNotes?: string;
  cashOnDelivery?: number;
  orderId?: string;
  passenger?: Passenger;
  createdAt?: number;
  vehicle?: Vehicle;
  pickupAddressLine?: string; //extended
  completedAt?: number; //extended
  proofImageUrl?: string;
  cancellationReason?: CancellationReason;
  deliveryAction?: DeliveryAction;
  bookingType?: DeliveryOption;
  expectedDeliveryWindow?: TimeSlotWithDate;
  expectedPickupTime?: string;
  dropOffLocationEdited?: boolean;
}

export type DeliveriesWithPageCount = {
  deliveries: Delivery[];
  count: number;
};

export interface QueuedDeliveryRequest {
  item: DeliveryRequest;
}

export interface RecreateDeliveryResponseDto {
  id: string;
  reference: number;
}

export interface CreateDeliveryResponseDto {
  id: string;
  reference: number;
}

export interface CreateDeliveryResponse {
  id?: number;
  bookingId?: string;
}

export enum DeliveryAction {
  LEAVE_AT_DOOR = 'LEAVE_AT_DOOR',
  CALL_MERCHANT = 'CALL_MERCHANT',
  RETURN = 'RETURN'
}

export enum PaymentOnDeliveryType {
  CASH = 'CASH',
  CCOD = 'CCOD'
}

export type DeliveryPriceEstimation = {
  tripCost: number;
  currency: string;
};
